import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Offcanvas, Dropdown } from "react-bootstrap";
import LKLogo from '../../../assets/images/landking-logo-transparent.png'
import BTATCIconLogo from "../../../assets/images/logo-btatc.png";
import WeichaiLogo from "../../../assets/images/weichai-logo-trans.png";
import "./Header.css";


export default function Header() {
    const { pathname } = useLocation();
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const handleNavClick = () => {
        setShowOffcanvas(false);
    };

    return (
        <header className="lk-header">
            <Navbar expand="lg" sticky="top" className="lk-navbar">
                <Container fluid>
                    {/* Brand / Logo */}
                    <Navbar.Brand as={NavLink} to="/" className="lk-brand d-flex align-items-center">
                        <img src={LKLogo} alt="LandKing Logo" className="lk-brand__img" />
                        <img src={BTATCIconLogo} alt="BTATC Logo" className="lk-brand__img" />
                        <img src={WeichaiLogo} alt="Weichai Logo" className="lk-brand__img-weichai" />
                    </Navbar.Brand>

                    {/* Toggler (mobile) */}
                    <Navbar.Toggle aria-controls="lk-offcanvas" className="border-0" onClick={() => setShowOffcanvas(true)} />

                    {/* Offcanvas for mobile */}
                    <Navbar.Offcanvas
                        id="lk-offcanvas"
                        aria-labelledby="lk-offcanvas-label"
                        placement="start"
                        show={showOffcanvas}
                        onHide={() => setShowOffcanvas(false)}
                    >
                        <Offcanvas.Header closeButton closeVariant="dark">
                            <Offcanvas.Title id="lk-offcanvas-label" className="fw-bold">
                                <Navbar.Brand as={NavLink} to="/" className="lk-brand-mob d-flex align-items-center" onClick={handleNavClick}>
                                    <img src={LKLogo} alt="LandKing Logo" className="lk-brand__img" />
                                    <img src={BTATCIconLogo} alt="BTATC Logo" className="lk-brand__img" />
                                    <img src={WeichaiLogo} alt="Weichai Logo" className="lk-brand__img-weichai" />
                                </Navbar.Brand>
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                            <Nav className="ms-md-auto lk-header-content">
                                <Nav.Link
                                    as={NavLink}
                                    to="/"
                                    end
                                    className="lk-link"
                                    onClick={handleNavClick}
                                >
                                    Home
                                </Nav.Link>

                                {/* Trucks dropdown */}
                                {/* <Dropdown as={Nav.Item} className="lk-dropdown">
                                    <Dropdown.Toggle
                                        as={NavLink}
                                        to="/trucks"
                                        className={`lk-link ${pathname.startsWith("/trucks") ? "active" : ""}`}
                                    >
                                        Trucks
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="lk-dropdown__menu" align="start">
                                        <Dropdown.Item
                                            as={NavLink}
                                            to="/trucks/h-series"
                                            className={({ isActive }) => (isActive ? "active" : "")}
                                        >
                                            H-Series
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            as={NavLink}
                                            to="/trucks/eh-series"
                                            className={({ isActive }) => (isActive ? "active" : "")}
                                        >
                                            EH-Series
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item
                                            as={NavLink}
                                            to="/trucks/compare"
                                            className={({ isActive }) => (isActive ? "active" : "")}
                                        >
                                            Compare Models
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                                <Nav.Link
                                    as={NavLink}
                                    to="/vehicles"
                                    className="lk-link"
                                    onClick={handleNavClick}
                                >
                                    Vehicles
                                </Nav.Link>

                                {/* <Nav.Link
                                    as={NavLink}
                                    to="/offers"
                                    className="lk-link"
                                >
                                    Offers
                                </Nav.Link> */}

                                <Nav.Link
                                    as={NavLink}
                                    to="/spare-parts"
                                    className="lk-link"
                                    onClick={handleNavClick}
                                >
                                    Spare Parts
                                </Nav.Link>

                                <Nav.Link
                                    as={NavLink}
                                    to="/services"
                                    className="lk-link"
                                    onClick={handleNavClick}
                                >
                                    Services
                                </Nav.Link>

                                <Nav.Link
                                    as={NavLink}
                                    to="/about-us"
                                    className="lk-link"
                                    onClick={handleNavClick}
                                >
                                    About Us
                                </Nav.Link>

                                <Nav.Link
                                    as={NavLink}
                                    to="/locations"
                                    className="lk-link"
                                    onClick={handleNavClick}
                                >
                                    Locations
                                </Nav.Link>



                                {/* <Nav.Link
                                    as={NavLink}
                                    to="/contact-us"
                                    className="lk-link"
                                >
                                    Contact Us
                                </Nav.Link> */}
                            </Nav>

                            {/* Right-side actions (optional CTA) */}
                            {/* <a href="/book-test-drive" className="btn btn-danger btn-sm">Book Test Drive</a> */}
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </header>
    );
}
